export const BUCKETING_API_URL = 'https://cdn.flagship.io/{0}/bucketing.json';
export const FS_FORCED_VARIATIONS = 'FS_FORCED_VARIATIONS';
export const FS_HITS = 'FS_HITS';
